"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameState = void 0;
const GameMap_1 = require("./GameMap");
const inversify_1 = require("inversify");
const SymbolClasses_1 = require("../Utils/SymbolClasses");
const GameEvent_1 = require("../Common/GameEvent");
const GameConfig_1 = require("./GameConfig");
const baseScore = {
    perfect: 10,
    great: 8,
    good: 5,
    bad: 2,
    miss: 0,
};
const lifeBonus = {
    perfect: 1,
    great: 0,
    good: -10,
    bad: -20,
    miss: -40,
};
const slideAmongLifeBonus = {
    perfect: 0,
    miss: -5,
};
function multiplier(life) {
    if (life > 90)
        return 10;
    if (life > 80)
        return 9;
    if (life > 60)
        return 8;
    if (life > 30)
        return 6;
    return 3;
}
const initLife = 100;
const maxScore = 1000000;
let GameState = class GameState {
    constructor(resources, config) {
        var _a;
        this.maxCombo = 0;
        this.currentCombo = 0;
        this.perfect = 0;
        this.great = 0;
        this.good = 0;
        this.bad = 0;
        this.miss = 0;
        this.on = {
            musicTimeUpdate: new GameEvent_1.GameEvent(),
            pointer: new GameEvent_1.GameEvent(),
            judge: new GameEvent_1.GameEvent(),
            /** [type, delay(in seconds)] */
            soundEffect: new GameEvent_1.GameEvent(),
            emptyTap: new GameEvent_1.GameEvent(),
            pause: new GameEvent_1.GameEvent(),
            continue: new GameEvent_1.GameEvent(),
            fullCombo: new GameEvent_1.GameEvent(),
            end: new GameEvent_1.GameEvent(),
            restart: new GameEvent_1.GameEvent(),
            abort: new GameEvent_1.GameEvent(),
        };
        this.GetMusicTime = () => 0;
        // -------------- private field ----------
        this.maxScore = 0;
        this.currentScore = 0;
        this.life = initLife;
        this._ended = false;
        this._paused = false;
        this.map = GameMap_1.fromRawMap(resources.map.data);
        if (config.mirror) {
            for (const n of this.map.notes)
                n.lane = 6 - n.lane;
        }
        this.musicTime = Math.min(-1, (((_a = this.map.notes[0]) === null || _a === void 0 ? void 0 : _a.time) || 0) - 5);
        this.maxScore = this.map.combo * 100;
        if (this.maxScore <= 0) {
            this.maxScore = 1;
            this.map.combo = 1;
        }
        this.on.judge.add((remove, note) => {
            if (this.ended)
                return remove();
            if (!note.judge)
                return;
            this.addJudge(note.judge, note.type === "slideamong");
        });
        this.on.end.add(() => {
            this._ended = true;
            for (const key in this.on) {
                ;
                this.on[key].clear();
            }
        });
        this.on.pause.add(() => {
            this._paused = true;
        });
        this.on.continue.add(() => {
            this._paused = false;
        });
    }
    get paused() {
        return this._paused;
    }
    get ended() {
        return this._ended;
    }
    get score() {
        return Math.round((this.currentScore * maxScore) / this.maxScore);
    }
    addJudge(j, isSlideAmong) {
        if (j === "perfect" || j === "great") {
            this.currentCombo++;
            if (this.maxCombo < this.currentCombo)
                this.maxCombo = this.currentCombo;
            if (this.currentCombo === this.map.combo)
                this.on.fullCombo.emit();
        }
        else {
            this.currentCombo = 0;
        }
        this[j]++;
        const base = baseScore[j];
        const lifeb = isSlideAmong ? slideAmongLifeBonus[j] : lifeBonus[j];
        if (lifeb === undefined)
            throw new Error("Slide among should be judged perfect or miss");
        this.life = Math.max(0, Math.min(initLife, this.life + lifeb));
        this.currentScore += base * multiplier(this.life);
    }
};
GameState = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [SymbolClasses_1.Resources, GameConfig_1.GameConfig])
], GameState);
exports.GameState = GameState;
//# sourceMappingURL=GameState.js.map